module.exports = __webpack_public_path__ + "img/nav-about.b506fd1.jpg";